import intl from "react-intl-universal";

import {createCluster} from "./createCluster";
import {addToCluster} from "./addToCluster";
import {WorkspaceModelType} from "@stores/WorkspaceStore";

import {UndoableAction} from "../common/UndoableAction";
import {UndoableActionGroup} from "../common/UndoableActionGroup";
import {undoableFunctionCall} from "../common/undoableFunctionCall";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { DataSourceManager } from "@stores/dataSources/DataSourceManager";
import { RootStoreModel } from "@stores/RootStore";
import {AppState} from "@stores/AppState";


export class UndoableCreateNewClusterAndAddItemToIt implements UndoableAction {
    private services: CrudServices;
    private appState: AppState;
    workspaceMST: WorkspaceModelType;
    itemId: string;
    clusterName: string;
    parentId: string | null;
    undoableGroup: UndoableActionGroup;

    constructor(
        services: CrudServices,
        appState: AppState,
        workspaceMST: WorkspaceModelType,
        itemId: string,
        clusterName: string,
        parentId: string | null = null,
    ) {
        this.services = services;
        this.appState = appState;
        this.undoableGroup = new UndoableActionGroup();
        this.workspaceMST = workspaceMST;
        this.itemId = itemId;
        this.clusterName = clusterName;
        this.parentId = parentId;
    }

    execute(): Promise<any> {
        return _createNewClusterAndAddItemToIt(this.services, this.appState, this.workspaceMST, this.itemId, this.clusterName, this.parentId, this.undoableGroup);
    }

    undo(): Promise<any> {
        return this.undoableGroup.undo();
    }
}

export const undoableCreateNewClusterAndAddItemToIt = (
    services: CrudServices,
    appState: AppState,
    workspaceMST: WorkspaceModelType,
    itemId: string,
    clusterName: string,
    parentId: string | null = null,
) => {
    const undoableAction = new UndoableCreateNewClusterAndAddItemToIt(services, appState, workspaceMST, itemId, clusterName, parentId);
    return undoableFunctionCall(undoableAction, intl.get('snackbar.item_moved_to_new_cluster', {clusterName}).d('Page added to a new cluster {clusterName}'));
}


const _createNewClusterAndAddItemToIt = (
    services: CrudServices,
    appState: AppState,
    workspaceMST: WorkspaceModelType,
    itemId: string,
    clusterName: string,
    parentId: string | null,
    undoableGroup?: UndoableActionGroup,
) => {
    return createCluster(
        services,
        {
            workspace: workspaceMST,
            appState,
            parentId,
            name: clusterName,
            noSelect: true,
        },
        undoableGroup,
    )
        .then((values) => {
            if (!values ) {
                return;
            }
            const [clusterMST, cluster] = values;
            if (clusterMST) {
                addToCluster(services, appState, itemId, clusterMST.id, workspaceMST, undoableGroup);
            }
        });
}

/* undo self conflict if change and delete in the same queue */
